import { useEffect, useState } from "react";
import { useAppContext } from "../../../context/AuthContext";
import { ArticleController, ArticleControllerType } from "../../../controller/article/ArticleController";
import AuthData from "../../../model/AuthData";
import { handleErrorMessage } from "../../../utils/Utils";

interface ArticleCardServiceType {
  typeList: any;
  figureDialogVisible: boolean;
  closeFigureDialog: any;
  openFigureDialog: any;
  figureList: any;
  selectedFigure: any;
  setSelectedFigure: any;
  originalDialogVisible: boolean;
  closeOriginalDialog: any;
  openOriginalDialog: any;
  reviewersDialogVisible: boolean;
  setReviewersDialogVisible: any;
  suggestReviewerDialogVisible: boolean;
  setSuggestReviewerDialogVisible: any;
  reviewers: any;
  authData: AuthData | undefined;
  reviewsArticle: any;
  setReviewsArticle: any;
}

export default function ArticleCardService({ data }: any): ArticleCardServiceType {
  const { typeList, showMessage, authData } = useAppContext();

  const [reviewers, setReviewers] = useState<any>([]);

  const { axiosGetArticleReviewers }: ArticleControllerType = ArticleController();

  const [figureDialogVisible, setFigureDialogVisible] = useState<boolean>(false);
  const [figureList, setFigureList] = useState<any>();
  const [selectedFigure, setSelectedFigure] = useState<any>();
  const [originalDialogVisible, setOriginalDialogVisible] = useState<boolean>(false);
  const [reviewersDialogVisible, setReviewersDialogVisible] = useState<boolean>(false);
  const [suggestReviewerDialogVisible, setSuggestReviewerDialogVisible] = useState<boolean>(false);
  const [reviewsArticle, setReviewsArticle] = useState<any>(undefined);

  const getArticleById = () => {
    if (data.id) {
      axiosGetArticleReviewers(data.id)
        .then((result: any) => {
          setReviewers(result.data);
        })
        .catch((error: any) => {
          handleErrorMessage(showMessage, error);
        });
    }
  };

  useEffect(() => {
    const figureListNew: any = {};
    if (data) {
      const revision = parseInt(data.revision) + 1;
      if (revision) {
        [...Array(revision)].forEach((element: any, index: number) => {
          const findElement = data.files?.filter((f: any) => f.type === "Figure" && parseInt(f.revision) === index);
          figureListNew[index] = findElement;
        });
      }
      getArticleById();
    }
    setFigureList(figureListNew);
    if (figureListNew) {
      setSelectedFigure(data.files?.find((f: any) => f.type === "Figure"));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data]);

  const closeFigureDialog = () => {
    setFigureDialogVisible(false);
  };

  const openFigureDialog = () => {
    setFigureDialogVisible(true);
  };

  const closeOriginalDialog = () => {
    setOriginalDialogVisible(false);
  };

  const openOriginalDialog = () => {
    setOriginalDialogVisible(true);
  };

  return {
    typeList,
    figureDialogVisible,
    closeFigureDialog,
    openFigureDialog,
    figureList,
    selectedFigure,
    setSelectedFigure,
    originalDialogVisible,
    closeOriginalDialog,
    openOriginalDialog,
    reviewersDialogVisible,
    setReviewersDialogVisible,
    suggestReviewerDialogVisible,
    setSuggestReviewerDialogVisible,
    reviewers,
    authData,
    reviewsArticle,
    setReviewsArticle,
  };
}

export type { ArticleCardServiceType };
